// extracted by extract-css-chunks-webpack-plugin
module.exports = {"header":"header_8fYYp","cruiseList":"cruiseList_O-1pU","ui_mask":"ui_mask_WDX4L"};